import { AnimationStateToggleButtonWrapper } from './AnimationStateToggleButtonWrapper';
import { BackgroundAnimationContainer } from './BackgroundAnimationContainer';
import { useAnimationState } from './useAnimationState';

type BackgroundAnimationContainerWrapperProps = {
  children: React.ReactNode;
  isPreSessionVibesOpen: boolean;
};

export function BackgroundAnimationContainerWrapper({
  children,
  isPreSessionVibesOpen,
}: BackgroundAnimationContainerWrapperProps) {
  const { lottieRef, currentState } = useAnimationState();

  if (isPreSessionVibesOpen) {
    return <>{children}</>;
  }

  return (
    <BackgroundAnimationContainer
      animationStateToggleButtonComponent={AnimationStateToggleButtonWrapper}
      currentAnimationState={currentState}
      lottieRef={lottieRef}
    >
      {children}
    </BackgroundAnimationContainer>
  );
}
